document.addEventListener('DOMContentLoaded', function () {
  const gallery = document.getElementById('hgallery');
  const container = document.getElementById('hg-pic-cont');
  const image = document.getElementById('hg-pic');

  if (!gallery || !container || !image) return;

  const isMobile = function () {
    return window.matchMedia(
      '(max-width: 768px)'
    ).matches;
  };

  const isDesktop = function () {
    return window.matchMedia(
      '(min-width: 769px)'
    ).matches;
  };

  /*
   * ==================================================
   * SP：ピンチ拡大
   * ==================================================
   */

  let mobileScale = 1;
  let mobileTranslateX = 0;
  let mobileTranslateY = 0;

  let mobileStartDistance = 0;
  let mobileStartScale = 1;

  let mobileStartX = 0;
  let mobileStartY = 0;

  let mobileStartTranslateX = 0;
  let mobileStartTranslateY = 0;

  let mobileMoved = false;

  /**
   * 2本指の間隔を取得
   */
  function getDistance(touches) {
    const x =
      touches[0].clientX -
      touches[1].clientX;

    const y =
      touches[0].clientY -
      touches[1].clientY;

    return Math.sqrt(x * x + y * y);
  }

  /**
   * SP画像の移動範囲を制限
   */
  function limitMobilePosition() {
    if (mobileScale <= 1) {
      mobileTranslateX = 0;
      mobileTranslateY = 0;
      return;
    }

    const imageWidth =
      image.offsetWidth * mobileScale;

    const imageHeight =
      image.offsetHeight * mobileScale;

    const containerWidth =
      container.clientWidth;

    const containerHeight =
      container.clientHeight;

    const maxTranslateX = Math.max(
      0,
      (imageWidth - containerWidth) / 2
    );

    const maxTranslateY = Math.max(
      0,
      (imageHeight - containerHeight) / 2
    );

    mobileTranslateX = Math.max(
      -maxTranslateX,
      Math.min(
        maxTranslateX,
        mobileTranslateX
      )
    );

    mobileTranslateY = Math.max(
      -maxTranslateY,
      Math.min(
        maxTranslateY,
        mobileTranslateY
      )
    );
  }

  /**
   * SPの拡大率と移動位置を反映
   */
  function applyMobileTransform() {
    limitMobilePosition();

    image.style.transform =
      'translate3d(' +
      mobileTranslateX +
      'px, ' +
      mobileTranslateY +
      'px, 0) scale(' +
      mobileScale +
      ')';
  }

  /**
   * SPの拡大状態をリセット
   */
  function resetMobileZoom(
    useAnimation
  ) {
    mobileScale = 1;
    mobileTranslateX = 0;
    mobileTranslateY = 0;

    image.style.transition =
      useAnimation
        ? 'transform 0.2s ease'
        : '';

    applyMobileTransform();

    if (useAnimation) {
      setTimeout(function () {
        image.style.transition = '';
      }, 200);
    }
  }

  /**
   * SP：タッチ開始
   */
  container.addEventListener(
    'touchstart',
    function (event) {
      if (!isMobile()) return;

      mobileMoved = false;

      /*
       * 2本指でピンチ開始
       */
      if (event.touches.length === 2) {
        event.preventDefault();

        mobileStartDistance =
          getDistance(event.touches);

        mobileStartScale =
          mobileScale;
      }

      /*
       * 拡大中は1本指で移動開始
       */
      if (
        event.touches.length === 1 &&
        mobileScale > 1
      ) {
        event.preventDefault();

        mobileStartX =
          event.touches[0].clientX;

        mobileStartY =
          event.touches[0].clientY;

        mobileStartTranslateX =
          mobileTranslateX;

        mobileStartTranslateY =
          mobileTranslateY;
      }
    },
    { passive: false }
  );

  /**
   * SP：タッチ移動
   */
  container.addEventListener(
    'touchmove',
    function (event) {
      if (!isMobile()) return;

      /*
       * 2本指で拡大・縮小
       */
      if (event.touches.length === 2) {
        event.preventDefault();

        mobileMoved = true;

        const currentDistance =
          getDistance(event.touches);

        mobileScale =
          mobileStartScale *
          (
            currentDistance /
            mobileStartDistance
          );

        /*
         * 拡大率は1〜4倍
         */
        mobileScale = Math.max(
          1,
          Math.min(mobileScale, 4)
        );

        if (mobileScale === 1) {
          mobileTranslateX = 0;
          mobileTranslateY = 0;
        }

        applyMobileTransform();
      }

      /*
       * 拡大中は1本指で移動
       */
      if (
        event.touches.length === 1 &&
        mobileScale > 1
      ) {
        event.preventDefault();

        mobileMoved = true;

        mobileTranslateX =
          mobileStartTranslateX +
          event.touches[0].clientX -
          mobileStartX;

        mobileTranslateY =
          mobileStartTranslateY +
          event.touches[0].clientY -
          mobileStartY;

        applyMobileTransform();
      }
    },
    { passive: false }
  );

  /**
   * SP：タッチ終了
   */
  container.addEventListener(
    'touchend',
    function () {
      if (!isMobile()) return;

      if (mobileScale < 1.05) {
        resetMobileZoom(true);
        return;
      }

      image.style.transition =
        'transform 0.15s ease';

      applyMobileTransform();

      setTimeout(function () {
        image.style.transition = '';
      }, 150);
    },
    { passive: false }
  );

  /**
   * SP：拡大操作後の誤クリックを防止
   */
  gallery.addEventListener(
    'click',
    function (event) {
      if (!isMobile()) return;

      if (mobileMoved) {
        event.preventDefault();
        event.stopPropagation();

        mobileMoved = false;
      }
    },
    true
  );

  /*
   * ==================================================
   * PC：ダブルクリックで2倍拡大
   * ==================================================
   */

  let desktopZoomed = false;
  let desktopDragging = false;

  let desktopTranslateX = 0;
  let desktopTranslateY = 0;

  let desktopStartX = 0;
  let desktopStartY = 0;

  let desktopStartTranslateX = 0;
  let desktopStartTranslateY = 0;

  /**
   * 操作案内を作成
   */
  const zoomHint =
    document.createElement('div');

  zoomHint.className =
    'product-image-zoom-hint';

  zoomHint.textContent =
    'ダブルクリックで拡大します';

  zoomHint.setAttribute(
    'aria-hidden',
    'true'
  );

  gallery.appendChild(zoomHint);

  /**
   * 操作案内をふわっと表示
   */
  function showDesktopZoomHint() {
    if (!isDesktop()) return;

    zoomHint.classList.remove(
      'is-visible'
    );

    /*
     * CSSアニメーションを再実行
     */
    void zoomHint.offsetWidth;

    zoomHint.classList.add(
      'is-visible'
    );

    setTimeout(function () {
      zoomHint.classList.remove(
        'is-visible'
      );
    }, 2600);
  }

  /**
   * PC画像の移動範囲を制限
   */
  function limitDesktopPosition() {
    if (!desktopZoomed) {
      desktopTranslateX = 0;
      desktopTranslateY = 0;
      return;
    }

    const scale = 3;

    const imageWidth =
      image.offsetWidth * scale;

    const imageHeight =
      image.offsetHeight * scale;

    const containerWidth =
      container.clientWidth;

    const containerHeight =
      container.clientHeight;

    const maxTranslateX = Math.max(
      0,
      (imageWidth - containerWidth) / 2
    );

    const maxTranslateY = Math.max(
      0,
      (imageHeight - containerHeight) / 2
    );

    desktopTranslateX = Math.max(
      -maxTranslateX,
      Math.min(
        maxTranslateX,
        desktopTranslateX
      )
    );

    desktopTranslateY = Math.max(
      -maxTranslateY,
      Math.min(
        maxTranslateY,
        desktopTranslateY
      )
    );
  }

  /**
   * PCの拡大率と移動位置を反映
   */
  function applyDesktopTransform(
    useAnimation
  ) {
    limitDesktopPosition();

    image.style.transition =
      useAnimation
        ? 'transform 0.2s ease'
        : '';

    image.style.transform =
      'translate3d(' +
      desktopTranslateX +
      'px, ' +
      desktopTranslateY +
      'px, 0) scale(' +
      (desktopZoomed ? 3 : 1) +
      ')';

    gallery.classList.toggle(
      'is-desktop-zoomed',
      desktopZoomed
    );

    if (useAnimation) {
      setTimeout(function () {
        image.style.transition = '';
      }, 200);
    }
  }

  /**
   * PCの拡大状態をリセット
   */
  function resetDesktopZoom(
    useAnimation
  ) {
    desktopZoomed = false;
    desktopDragging = false;

    desktopTranslateX = 0;
    desktopTranslateY = 0;

    gallery.classList.remove(
      'is-desktop-zoomed',
      'is-desktop-dragging'
    );

    applyDesktopTransform(
      useAnimation
    );
  }

  /**
   * PC：ダブルクリックで拡大・縮小
   */
  container.addEventListener(
    'dblclick',
    function (event) {
      if (!isDesktop()) return;

      event.preventDefault();
      event.stopPropagation();

      desktopZoomed =
        !desktopZoomed;

      desktopTranslateX = 0;
      desktopTranslateY = 0;

      applyDesktopTransform(true);
    }
  );

  /**
   * PC：ドラッグ開始
   */
  container.addEventListener(
    'mousedown',
    function (event) {
      if (
        !isDesktop() ||
        !desktopZoomed ||
        event.button !== 0
      ) {
        return;
      }

      event.preventDefault();

      desktopDragging = true;

      desktopStartX =
        event.clientX;

      desktopStartY =
        event.clientY;

      desktopStartTranslateX =
        desktopTranslateX;

      desktopStartTranslateY =
        desktopTranslateY;

      gallery.classList.add(
        'is-desktop-dragging'
      );
    }
  );

  /**
   * PC：ドラッグ中の画像移動
   */
  window.addEventListener(
    'mousemove',
    function (event) {
      if (
        !isDesktop() ||
        !desktopZoomed ||
        !desktopDragging
      ) {
        return;
      }

      event.preventDefault();

      desktopTranslateX =
        desktopStartTranslateX +
        event.clientX -
        desktopStartX;

      desktopTranslateY =
        desktopStartTranslateY +
        event.clientY -
        desktopStartY;

      applyDesktopTransform(false);
    }
  );

  /**
   * PC：ドラッグ終了
   */
  window.addEventListener(
    'mouseup',
    function () {
      if (!desktopDragging) return;

      desktopDragging = false;

      gallery.classList.remove(
        'is-desktop-dragging'
      );

      applyDesktopTransform(false);
    }
  );

  /**
   * PC：ウィンドウ外に移動した場合も終了
   */
  window.addEventListener(
    'blur',
    function () {
      if (!desktopDragging) return;

      desktopDragging = false;

      gallery.classList.remove(
        'is-desktop-dragging'
      );
    }
  );

  /*
   * ==================================================
   * 共通処理
   * ==================================================
   */

  /**
   * モーダルを開くたびに拡大状態をリセット
   *
   * openへの切り替わり時だけ実行することで、
   * MutationObserverの無限ループを防止
   */
  let galleryWasOpen =
    gallery.classList.contains('open');

  const galleryOpenObserver =
    new MutationObserver(function () {
      const galleryIsOpen =
        gallery.classList.contains('open');

      /*
       * 閉じた状態から開いた状態に
       * 変わった瞬間だけ実行
       */
      if (
        galleryIsOpen &&
        !galleryWasOpen
      ) {
        /*
         * 先に状態を更新して
         * クラス変更による再実行を防止
         */
        galleryWasOpen = true;

        if (isMobile()) {
          desktopZoomed = false;
          desktopDragging = false;

          desktopTranslateX = 0;
          desktopTranslateY = 0;

          gallery.classList.remove(
            'is-desktop-zoomed',
            'is-desktop-dragging'
          );

          resetMobileZoom(false);
        }

        if (isDesktop()) {
          mobileScale = 1;
          mobileTranslateX = 0;
          mobileTranslateY = 0;

          resetDesktopZoom(false);

          setTimeout(function () {
            showDesktopZoomHint();
          }, 300);
        }

        return;
      }

      galleryWasOpen = galleryIsOpen;
    });

  galleryOpenObserver.observe(gallery, {
    attributes: true,
    attributeFilter: ['class']
  });

  /**
   * 画像を切り替えたら拡大状態をリセット
   */
  const imageObserver =
    new MutationObserver(
      function (mutations) {
        mutations.forEach(
          function (mutation) {
            if (
              mutation.type ===
                'attributes' &&
              mutation.attributeName ===
                'src'
            ) {
              if (isMobile()) {
                resetMobileZoom(true);
              }

              if (isDesktop()) {
                resetDesktopZoom(true);
              }
            }
          }
        );
      }
    );

  imageObserver.observe(image, {
    attributes: true,
    attributeFilter: ['src']
  });

  /**
   * 画像一覧の画像をクリックした際に
   * PCの操作案内を表示
   */
  document.addEventListener(
    'click',
    function (event) {
      if (!isDesktop()) return;

      const galleryImage =
        event.target.closest(
          '.product-img-gallery img'
        );

      if (!galleryImage) return;

      setTimeout(function () {
        showDesktopZoomHint();
      }, 300);
    }
  );

  /**
   * 画面サイズ変更時
   */
  window.addEventListener(
    'resize',
    function () {
      if (isMobile()) {
        limitMobilePosition();
        applyMobileTransform();
      }

      if (
        isDesktop() &&
        desktopZoomed
      ) {
        limitDesktopPosition();
        applyDesktopTransform(false);
      }
    }
  );

  /**
   * 画面の向き変更時
   */
  window.addEventListener(
    'orientationchange',
    function () {
      setTimeout(function () {
        if (isMobile()) {
          limitMobilePosition();
          applyMobileTransform();
        }

        if (
          isDesktop() &&
          desktopZoomed
        ) {
          limitDesktopPosition();
          applyDesktopTransform(false);
        }
      }, 300);
    }
  );
});


/*
 * ==================================================
 * 商品詳細のメイン画像をクリック・タップしたら
 * 拡大モーダルを直接開く
 * ==================================================
 */

document.addEventListener('DOMContentLoaded', function () {
  const productSlider =
    document.querySelector(
      '.js-slider--product'
    );

  if (!productSlider) return;

  let touchStartX = 0;
  let touchStartY = 0;
  let touchMoved = false;

  /**
   * SP：タッチ開始位置
   */
  productSlider.addEventListener(
    'touchstart',
    function (event) {
      if (event.touches.length !== 1) {
        return;
      }

      touchStartX =
        event.touches[0].clientX;

      touchStartY =
        event.touches[0].clientY;

      touchMoved = false;
    },
    { passive: true }
  );

  /**
   * SP：スワイプとタップを判別
   */
  productSlider.addEventListener(
    'touchmove',
    function (event) {
      if (event.touches.length !== 1) {
        return;
      }

      const moveX = Math.abs(
        event.touches[0].clientX -
        touchStartX
      );

      const moveY = Math.abs(
        event.touches[0].clientY -
        touchStartY
      );

      if (moveX > 10 || moveY > 10) {
        touchMoved = true;
      }
    },
    { passive: true }
  );

  /**
   * メイン画像をクリック・タップ
   */
  productSlider.addEventListener(
    'click',
    function (event) {
      const clickedImage =
        event.target.closest(
          '.p-product__image img'
        );

      if (!clickedImage) return;

      /*
       * スワイプ直後は開かない
       */
      if (touchMoved) {
        touchMoved = false;
        return;
      }

      const slide =
        clickedImage.closest(
          '.p-product__image'
        );

      if (!slide) return;

      const galleryImages =
        document.querySelectorAll(
          '.product-img-gallery img:not([data-disabled])'
        );

      if (!galleryImages.length) return;

      let imageIndex = parseInt(
        slide.getAttribute(
          'data-slick-index'
        ),
        10
      );

      if (Number.isNaN(imageIndex)) {
        imageIndex = 0;
      }

      /*
       * Slickの複製画像番号を正規化
       */
      imageIndex =
        (
          (
            imageIndex %
            galleryImages.length
          ) +
          galleryImages.length
        ) %
        galleryImages.length;

      const targetImage =
        galleryImages[imageIndex];

      if (!targetImage) return;

      event.preventDefault();
      event.stopPropagation();

      targetImage.click();
    }
  );
});